import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-turns-reports-ticketpicked-card',
  templateUrl: './turns-reports-ticketpicked-card.component.html',
  styleUrls: ['./turns-reports-ticketpicked-card.component.scss']
})
export class TurnsReportsTicketpickedCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
